export enum SanifairRedemptionType {
  RESERVE = 'reserve',
  COMMIT = 'commit',
  UNCOMMIT = 'uncommit',
  REDEEM = 'redeem',
}
